import Mobile from "./mobile";

class Mobile1 extends Mobile {}

export default Mobile1;
